var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"mx-auto",attrs:{"eager":"","width":"180","height":"180","src":"/assets/icon/no-data-green.svg"}})}
var staticRenderFns = []

export { render, staticRenderFns }